import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();
const webType = process.env.REACT_APP_WEB_TYPE;

export const AuthProvider = ({ children, navigate }) => {
    navigate = useNavigate();

    const [auth, setAuth] = useState({
        isAuthenticated: false,
        user: null,
        initializing: true, // Tambahkan state untuk menandai proses inisialisasi,
        permissions: null
    });

    useEffect(() => {
        // Initialize auth state from localStorage
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            const userData = JSON.parse(storedUser);
            setAuth({
                isAuthenticated: true,
                user: userData,
                initializing: false, // Set initializing ke false setelah selesai inisialisasi
            });
        } else {
            setAuth({
                isAuthenticated: false,
                user: null,
                initializing: false, // Set initializing ke false setelah selesai inisialisasi
            });
        }
    }, []);

    useEffect(() => {
        const body = document.getElementById('lique-body');
        let isCustomer = true;
        if (auth?.user) {
            if (auth.user.accessRight?.position !== "Customer") {
                isCustomer = false;
            }
        }

        if (isCustomer) {
            body.classList.add("customer");
        } else {
            body.classList.remove("customer");
        }

    }, [auth]);

    const login = (userData) => {
        localStorage.setItem('user', JSON.stringify(userData));
        setAuth({
            isAuthenticated: true,
            user: userData,
            initializing: false, // Pastikan initializing tetap false setelah login
        });
        navigateBasedOnRole(userData);
    };

    const logout = () => {
        localStorage.removeItem('user');
        setAuth({
            isAuthenticated: false,
            user: null,
            initializing: false, // Pastikan initializing tetap false setelah logout
        });
        navigate('/login');
    };

    const updateProfile = (userName, phoneNumber) => {
        const newAuth = auth;
        auth.user.username = userName;
        auth.user.phonenumber = phoneNumber;
        localStorage.setItem('user', JSON.stringify(auth.user));

        setAuth(newAuth);
    }

    const navigateBasedOnRole = (getEmployee) => {
        switch (getEmployee.accessRight.id) {
            case 1:
                navigate('/manager/orderDelivery/pemesanan2');
                break;
            case 2:
            case 3:
                navigate('/manager/karyawan/presensi');
                break;
            case 4:
                navigate('/');
                break;
            case 5:
                navigate('/manager/stok/reviewStok');
                break;
            case 6:
                navigate('/manager/decoration/banner');
                break;
            default:
                navigate('/login');
        }
    };

    const getStringNavigateBasedOnRole = (getEmployee) => {
        if (!getEmployee) {
            if (webType === 'admin') {
                return '/login';
            } else {
                return '/home'
            }
        }

        switch (getEmployee.accessRight.id) {
            case 1:
                return '/manager/orderDelivery/pemesanan2';
            case 2:
            case 3:
                return '/manager/karyawan/presensi';
            case 5:
                return '/manager/stok/reviewStok';
            default:
                if (webType === 'admin') {
                    return '/login';
                } else {
                    return '/home'
                }
        }
    };

    const isAllowed = (permissionKey) => {
        return auth.user?.accessRight?.[permissionKey] === true;
    };

    const isAllowedMultiple = (permissionKeys) => {
        let allowed = false;
        for (const permission of permissionKeys) {
            if (auth.user?.accessRight?.[permission]) {
                allowed = true;
                break;
            }
        }

        return allowed;
    }

    return (
        <AuthContext.Provider value={{ auth, login, logout, updateProfile, isAllowed, isAllowedMultiple, getStringNavigateBasedOnRole }}>
            {!auth.initializing && children} {/* Hanya render children setelah selesai inisialisasi */}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
